import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../domain/forgot-password.validation';

const selectForgotPassword = (state: RootState) => state.forgotPassword;

export const selectDraft = (state: RootState) => selectForgotPassword(state).draft;
export const selectStatus = (state: RootState) => selectForgotPassword(state).status;
export const selectError = (state: RootState) => selectForgotPassword(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectForgotPassword(state).validationErrors;
export const selectIsSubmitting = (state: RootState) =>
  selectForgotPassword(state).status === 'submitting';
/** Has the reset link been requested successfully? Drives the confirmation view. */
export const selectHasSent = (state: RootState) =>
  selectForgotPassword(state).status === 'succeeded';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);
